import { defineStyle } from "@chakra-ui/react";

//Custom ToolTip Label Styling
export const customToolTipVariant = {
  subtopicNamesText: defineStyle({
    color: "#71717A",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px",
    fontFamily: "Poppins, Text-xs/Regular",
  }),
  subtopicTitle: defineStyle({
    color: "#7464CE",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    fontFamily: "Poppins, Text-sm/Semibold",
  }),
  loginTitle: defineStyle({
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
  }),

  normalTexts: defineStyle({
    color: "#7464CE",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    fontFamily: "Poppins, Text-sm/Semibold",
  }),
  labelToolTipBox: defineStyle({
    flexWrap: "wrap",
  }),
  toolTipBox: defineStyle({
    width: "200px",
    height: "max-content",
    backgroundColor: "#fff8f7",
    padding: "8px",
    gap: "8px",
    borderRadius: "6px",
    borderWidth: "1px",
    borderColor: "#e5e7eb",
  }),
  loginTipBox: defineStyle({
    display: "flex",
    width: "246px",
    padding: "14px 17px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    borderRadius: "6px",
    border: "1px solid #E5E7EB",
    background: "var(--Secoundary-50, #323030)",
    boxShadow: "0px 4px 4px 0px rgba(174, 174, 174, 0.25)",
  }),
  TaskCardIcon: defineStyle({
    width: "24px",
    height: "24px",
  }),
  updatesMobileIcon: defineStyle({
    width: "24px",
    height: "24px",
  }),
  updatesDesktopIcon: defineStyle({
    width: "42px",
    height: "42px",
  }),
};
